/* eslint-disable no-prototype-builtins */
import { Typography } from '@one-thd/sui-atomic-components';
import React, { useState, Fragment, useEffect } from 'react';
import { SpendMapSkeleton } from './BusinessToolsSkeletons';
import { GetTopSpendByStore } from '../../hooks/business-tools-hooks';
import { useBusinessToolsContext, useCommonContext, } from '../../hooks/useContexts';
import { DateRanges } from '../../utils/DateRanges';
import { getWindow } from '../../utils/general';
import { getSvocId } from '../../utils/user';
import { SectionHeader } from '../shared/section-header/SectionHeader';
import { BusinessToolsErrorMessage } from './BuisnessToolsErrorMessage';
import '../../styles/business-tools.scss';
/**
 *  create bing map with call back able to access the spendMap prop
 * @param data
 */
var bingMap = function (storeSpends, setRenderBingMapState) {
    var body = document.getElementsByTagName('body')[0];
    var scripTag = document.createElement('script');
    scripTag.setAttribute('type', 'text/javascript');
    scripTag.setAttribute('src', 'https://www.bing.com/api/maps/mapcontrol?callback=GetMap');
    body.appendChild(scripTag);
    if (getWindow()) {
        window.GetMap = function () {
            // if Microsoft is an object then display map is not available
            if (typeof window.Microsoft !== 'object') {
                setRenderBingMapState(false);
                // this.setState({ bingMap: false });
                return true;
            }
            // get from data parameter storeSpend response array
            // ** new **const dataArray = data; ** old ** data.payload.data.businessToolsResponse.storesSpend;
            // create new array
            var findingCoordinates = [];
            // boolean flag when false means no cooridnates where found from the response
            var findingCoordinatesBool = false;
            // lets find coordinates from storeSpends array to display on map
            storeSpends.forEach(function (spend) {
                if (spend.coordinates) {
                    if (spend.coordinates.hasOwnProperty('latitude')) {
                        // push coordinates found in storeSpends array
                        findingCoordinates.push(spend);
                        // coordinates where found update value to true
                        findingCoordinatesBool = true;
                    }
                }
            });
            // declare map
            var map = new window.Microsoft.Maps.Map('#myMap', {
                credentials: 'Aif9kL_IbQO95flnHttxLsFlCrSI7tAzf5FlUWJdLw-VN-J1LtxGVx6GUPrbnfqV',
                liteMode: true,
                zoom: 10,
            });
            // if true load map options with Microsoft Maps Location
            if (findingCoordinatesBool) {
                // loading map with Microsoft Maps Location because we have coordinates from dataArray
                map.center = new window.Microsoft.Maps.Location(findingCoordinates[0].coordinates.latitude, findingCoordinates[0].coordinates.longitude);
            }
            else {
                // no coordinates where found display map with the users default location with no pins
                return true;
            }
            // if coordinates found for loop and create push pins with them
            for (var i = 0; i < findingCoordinates.length; i += 1) {
                var pin = new window.Microsoft.Maps.Pushpin(new window.Microsoft.Maps.Location(findingCoordinates[i].coordinates.latitude, findingCoordinates[i].coordinates.longitude), {
                    icon: "<svg width=\"30px\" height=\"39px\" viewBox=\"0 0 30 39\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-36.000000, -268.000000)\" fill=\"#F96302\"><path d=\"M50.590202,268 C42.8105556,268 36,274.2402 36,281.94205 C36,289.08425 50.4245455,306.1792 50.4245455,306.1792 C50.4245455,306.1792 65.3688384,289.3241 65.3688384,281.94205 C65.3688384,274.2402 58.3677778,268 50.590202,268 L50.590202,268 Z M50.6833838,289.87965 C46.2769192,289.87965 42.7049495,286.3434 42.7049495,281.981 C42.7049495,277.6186 46.2769192,274.0803 50.6833838,274.0803 C55.0919192,274.0803 58.6638889,277.6186 58.6638889,281.981 C58.6638889,286.3434 55.0919192,289.87965 50.6833838,289.87965 L50.6833838,289.87965 Z\"></path></g></g><circle xmlns=\"http://www.w3.org/2000/svg\" fill=\"#fff\" cx=\"14.5\" cy=\"14\" r=\"10\"/><text text-anchor=\"middle\" x=\"14\" y=\"18\" style=\"text-align: center; font-size: 12px; color: #000; font-weight: bold; font-family: Helvetica Neue,Helvetica-,Arial,sans-serif;\">".concat(findingCoordinates[i].serialNumber, "</text></svg>"),
                });
                // push each push pin on each loop
                map.entities.push(pin);
            }
            return undefined;
        };
    }
};
// map over array and return html and values
var spendMapTable = function (spenMapData, redirectQueryParams, businessToolsHostName) {
    return spenMapData.map(function (data, i) {
        if (data.hasOwnProperty('totalSpend')) {
            var hostFlag = businessToolsHostName || 'b2b/account/view/order/summary';
            var redirectUrl = redirectQueryParams.startDate
                ? "".concat(hostFlag, "?requestSearchSelectorValue=storeNumber&requestSearchCriteria=").concat(data.storeNumber, "&startDate=").concat(redirectQueryParams.startDate, "&endDate=").concat(redirectQueryParams.endDate, "&dateSelectorValue=").concat(redirectQueryParams.dateSelectorValue)
                : "".concat(hostFlag, "?requestSearchSelectorValue=storeNumber&requestSearchCriteria=").concat(data.storeNumber, "&dateSelectorValue=").concat(redirectQueryParams.dateSelectorValue);
            if (redirectQueryParams.poJobName !== 'all') {
                Object.assign(redirectQueryParams, {
                    searchBy: [
                        {
                            storeNumber: data.storeNumber,
                            POJobName: redirectQueryParams.poJobName,
                        },
                    ],
                });
            }
            var storeNameLink = void 0;
            if ((data.hasOwnProperty('storeNumber') && data.storeNumber === '8119') ||
                (data.hasOwnProperty('storeName') && data.storeName === 'homedepot.com')) {
                storeNameLink = 'Homedepot.com';
            }
            else {
                storeNameLink =
                    (data.hasOwnProperty('storeNumber') ? "#".concat(data.storeNumber, " ") : ' ') +
                        (data.hasOwnProperty('storeName') ? data.storeName : '');
            }
            return (React.createElement("tr", { key: i, className: "business-tools__borderBottom" },
                React.createElement("th", { scope: "row u--padding" }, i + 1),
                React.createElement("td", { className: "u--padding" },
                    React.createElement(Typography
                    // href={redirectUrl}
                    , null, storeNameLink)),
                React.createElement("td", { className: "u--padding" }, data.phoneNumber ? data.phoneNumber : ''),
                React.createElement("td", { className: "business-tools__rmPaddingRight  u__text-align--right" }, "$".concat(data.totalSpend.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                })))));
        }
        return React.createElement(Fragment, { key: i });
    });
};
var renderSpendByMapElement = function (topSpendByStore, topSpendByStoreError, topSpendByStoreLoaded, redirectQueryParams, renderBingMap, businessToolsHostName) {
    if (topSpendByStoreLoaded) {
        if (topSpendByStoreError) {
            return BusinessToolsErrorMessage();
        }
        if (topSpendByStore &&
            topSpendByStore.businessToolsResponse.storesSpend.length > 0) {
            return (React.createElement(React.Fragment, null,
                ' ',
                React.createElement("div", { className: "business-tools__fullWidth u__flex business-tools__subHeader business-tools__marginTop" },
                    React.createElement("h4", null, "Highest to Lowest"),
                    React.createElement("h4", null, "Displays Pre-Tax Dollar Spend"),
                    ' '),
                React.createElement("div", { className: "u__clearfix business-tools__marginTop" },
                    React.createElement("div", { className: "col__12-12 col__6-12--md business-tools__rmPaddingLeft" }, renderBingMap ? (React.createElement("div", { id: "myMap", "data-testid": "bingMap" })) : (React.createElement("div", { style: { color: 'red' } },
                        React.createElement("h2", null, "We're sorry. Maps are currently unavailable.")))),
                    React.createElement("div", { className: "col__12-12 col__6-12--md business-tools__rmPaddingRight" },
                        React.createElement("table", { className: "table col__12-12 u__text-align--left" },
                            React.createElement("thead", { className: "u__border--bottom" },
                                React.createElement("tr", null,
                                    React.createElement("th", { scope: "col", className: "business-tools__rmPaddingLeft" }, "#"),
                                    React.createElement("th", { scope: "col", className: "u--padding" }, "Store Name"),
                                    React.createElement("th", { scope: "col", className: "u--padding" }, "Phone"),
                                    React.createElement("th", { scope: "col", className: "u__text-align--right" }, "Amount"))),
                            React.createElement("tbody", null, spendMapTable(topSpendByStore === null || topSpendByStore === void 0 ? void 0 : topSpendByStore.businessToolsResponse.storesSpend, redirectQueryParams, businessToolsHostName)))))));
        }
        return (React.createElement(Typography, { weight: "bold" }, "No records can be found for the selected date range and/or job name."));
    }
    return React.createElement(SpendMapSkeleton, null);
};
export var SpendMap = function () {
    var _a = useState(true), renderBingMap = _a[0], setRenderBingMapState = _a[1];
    var dateRangeOptions = useCommonContext().dateRangeOptions;
    var _b = useBusinessToolsContext(), dateSelectorValue = _b.dateSelectorValue, requestData = _b.requestData, businessToolsHostName = _b.businessToolsHostName;
    var request = {
        businessToolsRequest: {
            startDate: dateSelectorValue === 'custom'
                ? dateRangeOptions.startDate
                : DateRanges[dateSelectorValue].startDate,
            endDate: dateSelectorValue === 'custom'
                ? dateRangeOptions.endDate
                : DateRanges[dateSelectorValue].endDate,
            jobName: requestData.poJobName,
        },
        customerAccountId: getSvocId() || '',
    };
    var redirectQueryParams = {
        startDate: dateSelectorValue === 'custom'
            ? dateRangeOptions.startDate
            : DateRanges[dateSelectorValue].startDate,
        endDate: dateSelectorValue === 'custom'
            ? dateRangeOptions.endDate
            : DateRanges[dateSelectorValue].endDate,
        dateSelectorValue: dateSelectorValue || 'YTD',
        poJobName: requestData.poJobName || '',
    };
    var _c = GetTopSpendByStore(request), topSpendByStore = _c.topSpendByStore, topSpendByStoreError = _c.topSpendByStoreError, topSpendByStoreLoaded = _c.topSpendByStoreLoaded;
    useEffect(function () {
        if ((topSpendByStore === null || topSpendByStore === void 0 ? void 0 : topSpendByStore.businessToolsResponse.storesSpend) !== undefined) {
            // call action to fetch api spendbymap then call bing map function
            bingMap((topSpendByStore === null || topSpendByStore === void 0 ? void 0 : topSpendByStore.businessToolsResponse.storesSpend) || [], setRenderBingMapState);
        }
    }, [topSpendByStore === null || topSpendByStore === void 0 ? void 0 : topSpendByStore.businessToolsResponse.storesSpend]);
    return (React.createElement("div", { className: "spend-map" },
        React.createElement(SectionHeader, { title: "Spend Map" }),
        renderSpendByMapElement(topSpendByStore, topSpendByStoreError, topSpendByStoreLoaded, redirectQueryParams, renderBingMap, businessToolsHostName)));
};
